<script setup lang="ts">
import type CasinoGamesHeader from './Header.vue';

const casino = useCasinoStore();
const { bannersCasinoFiltered } = storeToRefs(useAppearanceStore());

const games: any = ref([]);
const callCount = ref<number>(0);
const headerRef = ref<InstanceType<typeof CasinoGamesHeader> | null>(null);
const pagination = ref<any>({});

const updateGamesList = (gamesData: any[]) => {
  games.value = gamesData;
  callCount.value++;
};

const updatePagination = (paginationData: any) => {
  pagination.value = paginationData;
};

const loadMoreGames = () => {
  if (pagination.value.currentPage !== pagination.value.lastPage) {
    headerRef.value?.fetchGames({ moreGames: true });
  }
};
</script>

<template>
  <div class="games">
    <template v-if="$slots.banners">
      <slot name="banners">
        <SectionsSlider :banners="bannersCasinoFiltered" />
      </slot>
    </template>

    <section class="spacing">
      <CasinoGamesHeader
        ref="headerRef"
        @update-games-list="updateGamesList"
        @update-pagination="updatePagination"
      />

      <CasinoLastGamesPlayed />

      <div class="games_content">
        <CasinoMediaList
          display-mode="list"
          :is-loading="casino.isLoading"
          :is-loading-more-games="casino.isLoadingMoreGames"
          :items="games?.data"
          :per-row="{ 768: 3, 1100: 4, 1200: 5, desktop: 6 }"
        />
      </div>

      <CasinoGamesPagination
        :pagination="pagination"
        @load-more-games="loadMoreGames"
      />
    </section>
  </div>
</template>

<style scoped lang="scss">
.games {
  @apply flex flex-col xl:pt-5;

  .spacing {
    @apply p-3 pt-0 px-0;
  }

  .games_content {
    .bt_link {
      @apply bg-white text-black py-3 px-5 rounded-md text-base gap-2 inline-flex m-0 items-center justify-center shadow-md hover:opacity-90 hover:text-primary whitespace-nowrap w-auto;
    }
  }
}
</style>
